export const EMPTY_DEPARTMENT_NAME = 'NoCategory';

export const GENERAL_APPLICATION_NAME = 'General Application';


// WEBPACK FOOTER //
// ./lib/rlink-recruiting/constants.js